var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.204 29.678C56.204 18.258 46.947 9 35.526 9c-9.748 0-17.921 6.746-20.105 15.825.2-.12.406-.231.616-.334 1.428-.7 2.677-.93 4.576-.93 3.178.013 5.84 1.74 7.353 4.388a7.754 7.754 0 1 1 1.298 6.302 11.794 11.794 0 0 1-.716 3.051l.115.108a10.314 10.314 0 0 0 4.355 2.3l-1.881 7.525-.801-.22a18.046 18.046 0 0 1-6.195-3.275 30.706 30.706 0 0 1-1.923 1.765 20.595 20.595 0 0 0 13.308 4.85c11.42 0 20.678-9.257 20.678-20.677ZM36.17 39.998a10.32 10.32 0 0 0 1.863-.287l1.883 7.524-.85.19a18.177 18.177 0 0 1-3.54.346v-7.754l.644-.02Zm1.865-20.353 1.881-7.524.801.22c2.91.87 5.511 2.451 7.603 4.543l-5.483 5.483-.447-.421a10.314 10.314 0 0 0-4.355-2.3Zm-6.048-7.714a18.178 18.178 0 0 1 3.54-.346v7.754l-.645.02a10.33 10.33 0 0 0-1.864.286l-1.881-7.524.85-.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.616 27.907c.165-.106.335-.202.513-.29.93-.454 1.704-.598 3.168-.598 3.04.013 5.302 2.592 5.302 6.09 0 2.896-1.768 5.959-5.297 9.133-1.873 1.685-4.266 3.374-6.002 4.32-1.737-.946-4.129-2.635-6.003-4.32C5.768 39.068 4 36.005 4 33.11c0-3.553 2.225-6.09 5.307-6.09 1.394 0 2.224.16 3.184.634a5.054 5.054 0 0 1 1.461 1.082l1.225 1.306.965-1.048c.412-.447.885-.8 1.422-1.062l.052-.025ZM35.526 27.093a2.585 2.585 0 1 1 0 5.17 2.585 2.585 0 0 1 0-5.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteTrack);
export default __webpack_public_path__ + "static/media/favorite-track.6dae859b.svg";
export { ForwardRef as ReactComponent };